const CTA = () => {
  return (
    <section className="bg-[#060f1e] py-24 px-6" id="demo">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background */}
          <img
            src="https://public.readdy.ai/ai/img_res/784bb4998bbeb6f3de9e563b609140c8.jpg"
            alt="CTA Background"
            className="absolute inset-0 w-full h-full object-cover object-center opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#0f2040] via-[#0a1628] to-[#0f2040]"></div>

          {/* Accent elements */}
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-[#3b82f6]/10 rounded-full blur-3xl pointer-events-none"></div>
          <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-[#f97316]/10 rounded-full blur-3xl pointer-events-none"></div>

          <div className="relative z-10 py-16 px-8 md:py-20 md:px-16 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#f97316]/15 border border-[#f97316]/30 rounded-full mb-6">
              <span className="w-2 h-2 bg-[#f97316] rounded-full animate-pulse"></span>
              <span className="text-[#f97316] text-xs font-semibold tracking-widest uppercase">Limited Spots Available — April 2026</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 max-w-3xl mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Ready to Transform Your
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#3b82f6] to-[#f97316]">
                Automotive Business?
              </span>
            </h2>

            <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
              Join leading South African workshops and parts suppliers using PRODIFY to streamline operations and increase revenue. Get started with a free 14-day trial — no credit card required.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <a
                href="#demo"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold rounded-xl transition-all duration-200 text-base whitespace-nowrap"
              >
                <i className="ri-calendar-check-line"></i>
                Book Your Demo Today
              </a>
              <a
                href="#features"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 hover:bg-white/15 border border-white/20 text-white font-semibold rounded-xl transition-all duration-200 text-base whitespace-nowrap"
              >
                <i className="ri-apps-line"></i>
                Explore All Features
              </a>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap justify-center gap-8">
              {[
                { icon: 'ri-shield-check-line', text: 'SARS VAT Compliant' },
                { icon: 'ri-lock-line', text: 'Bank-Grade Security' },
                { icon: 'ri-customer-service-2-line', text: 'SA-Based Support' },
                { icon: 'ri-refresh-line', text: '99.9% Uptime SLA' },
              ].map((badge, i) => (
                <div key={i} className="flex items-center gap-2 text-gray-400">
                  <i className={`${badge.icon} text-[#3b82f6] text-lg`}></i>
                  <span className="text-sm">{badge.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
